import { backendApi } from "../../api";
import { Default } from "../types/default";

const defaultCatalogApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    textblocksDefaultCatalogPut: build.mutation<Default, PutRequest>({
      query: (request) => ({
        url: `/textblocks/default-catalog`,
        method: "PUT",
        body: request,
      }),
      invalidatesTags: ["TextblocksDefaultCatalog"],
    }),
    textblocksDefaultCatalogShow: build.query<Default, ShowRequest>({
      query: (request) => ({
        url: `/textblocks/default-catalog/${request.identifier}`,
        method: "GET",
      }),
      providesTags: ["TextblocksDefaultCatalog"],
    }),
    textblocksDefaultCatalogList: build.query<List, ListRequest>({
      query: (request) => ({
        url: `/textblocks/default-catalog`,
        method: "GET",
        params: { request: btoa(JSON.stringify(request)) },
      }),
      providesTags: ["TextblocksDefaultCatalog"],
    }),
    textblocksDefaultCatalogDelete: build.mutation<Default, DeleteRequest>({
      query: (request) => ({
        url: `/textblocks/default-catalog`,
        method: "Delete",
        body: request,
      }),
      invalidatesTags: ["TextblocksDefaultCatalog"],
    }),
  }),
});

export const {
  useTextblocksDefaultCatalogPutMutation,
  useTextblocksDefaultCatalogShowQuery,
  useTextblocksDefaultCatalogListQuery,
  useTextblocksDefaultCatalogDeleteMutation,
} = defaultCatalogApi;

export interface PutRequest {
  identifier: string;
  catalogId: string;
}

export interface ShowRequest {
  identifier: string;
}

export type ListRequest = object;

export interface List {
  items: Default[];
}

export interface DeleteRequest {
  identifier: string;
}
